import type { TransformModelFn } from "@/__main__/data-model.mjs";
import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import { SERVICES_TO_REGIONS } from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplates from "@/game-lol/graphql-templates.mjs";
import MatchModel from "@/game-lol/models/lol-match.mjs";
import { matchStatePath } from "@/game-lol/utils/match-utils.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function getMatch({ region, matchId }) {
  if (!region || !SERVICES_TO_REGIONS[region.toLowerCase()]) return null;
  if (!matchId) return null;

  return queryGQL(appURLs.RIOT, GraphQLTemplates.LeagueMatch, {
    region: region.toUpperCase(),
    matchId,
  });
}

export default function ({
  region,
  matchId,
  options = {},
}: {
  region: string;
  matchId: string | number;
  options?: object;
}): Promise<void> {
  const path = matchStatePath(region, Number(matchId), null);
  return getData(
    getMatch({ region, matchId }),
    MatchModel as TransformModelFn<unknown, never>,
    path,
    {
      shouldFetchIfPathExists: false,
      ...options,
    },
  );
}
